import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[agrFileUploadErrorsTemplate]' })
export class FileUploadErrorsTemplateDirective<T> {
  constructor(public templateRef: TemplateRef<T>) {}
}
